import { render, staticRenderFns } from "./parent-create.vue?vue&type=template&id=89539740&scoped=true&"
import script from "./parent-create.vue?vue&type=script&lang=js&"
export * from "./parent-create.vue?vue&type=script&lang=js&"
import style0 from "./parent-create.vue?vue&type=style&index=0&id=89539740&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89539740",
  null
  
)

export default component.exports